import { __assign, __rest } from "tslib";
import React from 'react';
import { cnCheckbox } from '../Checkbox';
import './Checkbox-Control.css';
export var CheckboxControl = function (_a) {
    var controlRef = _a.controlRef, className = _a.className, tabIndex = _a.tabIndex, required = _a.required, props = __rest(_a, ["controlRef", "className", "tabIndex", "required"]);
    return (React.createElement("input", __assign({}, props, { tabIndex: tabIndex, required: required, 
        // Отключаем autoComplete, чтобы в FireFox
        // не сохранялось значение при перезагрузке страницы.
        autoComplete: "off", className: cnCheckbox('Control', null, [className]), ref: controlRef, type: "checkbox" })));
};
